import React from 'react';
import BaseCardDetailInformation from '@src/pages/ticketCompliments/cardOrders/cardInformation/CardDetailInformation';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';
const CardDetailInformation = (props) => {
  return (
    <BaseCardDetailInformation
      {...props}
      vouId={VouIdCode.Market}
      uploadModalProps={{ isMarket: true }}
      showExistingUsersPickerButton={false}
      enableDigitalContactInfo={false}
    />
  );
};
CardDetailInformation.propTypes = {
  form: PropTypes.any,
  resetCard: PropTypes.func,
};

export default CardDetailInformation;
